import script from "./SubscriptionsHolder.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionsHolder.vue?vue&type=script&setup=true&lang=ts"

import "./SubscriptionsHolder.vue?vue&type=style&index=0&id=52559feb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52559feb"]])

export default __exports__